export default {
  scorecard: {
    title: '評分卡',
    content: '內容',
    award: 'ESG大獎',
  },
  list_table_filter: {
    table_buyer_company_name: '委託評估企業',
    table_question_group_name: '問卷',
    table_status: '狀態',
    table_issue_at: '發行日',
    table_sustaina_rate: 'ESG評級',
    table_esg_score: 'ESG評分',
    table_operation: '操作',
    displayed_items_number: '全部 {total} 件　顯示 {start}〜{end} 件',
    displayed_items_number_empty: '全部 0 件　顯示 0 件',
    no_data_display: '無可顯示的資料。',
    csv_modal_title: '請選擇輸出CSV檔的內容',
    csv_modal_answer_status_title: '回答狀況',
    csv_modal_answer_status_text: '輸出受評企業回答狀況的一覽表。',
    csv_modal_answer_title: '回答（每個檔案500家）',
    csv_modal_answer_title_by_individual_company: '回答（每個檔案1家）',
    csv_modal_answer_text: '受評企業的回答內容，每500家會輸出成1個檔案。',
    csv_modal_answer_text_by_individual_company: '受評企業的回答內容，每1家會輸出成1個檔案。',
    csv_modal_score_title: '評分',
    csv_modal_score_text: '將受評企業的評級和評分輸出成一覽表。',
    csv_modal_answer_heading: '標題行',
    csv_modal_answer_heading_supplier: '受評估企業',
    csv_modal_answer_heading_question: '提問',
    csv_modal_answer_additional: '增加項目',
    csv_modal_answer_additional_note: '備註',
    csv_modal_answer_additional_file: '附加檔案名稱',
    csv_modal_cautionary_note_title: '注意',
    csv_modal_cautionary_note_content: '・輸出對象為{questionGroupName}的回答狀況、回答與評分。\n・回答狀況是以所有受評企業為對象，無論調查表／問卷的回答狀態為何。\n・回答、評分的對象不包含調查表／問卷的回答狀態為「未回答」的受評企業。\n・每個CSV檔案中，回答、評分的顯示公司數上限為1,000家。\n・統計後的回答與評分CSV檔案，會寄送至登入中帳號的電子郵件地址。',
    csv_modal_sent_mail_section_one: '已受理輸出CSV檔要求。',
    csv_modal_sent_mail_section_two: 'CSV下載URL會寄送至電子郵件地址，請稍候。',
    csv_modal_sent_mail_section_three: '30分鐘後仍未收到郵件時請重試。',
  },
  overall_score_section: {
    card_title: '調查內容',
    score: '評分',
    esg_score: 'ESG評分',
    esg_rating: 'ESG評級',
    esg_score_tip: 'ESG評分是將針對　貴公司的ESG措施所做的評估，化為評分的數値。這是以ASUENE ESG的調查表／問卷調查回答內容為計算基礎。',
    esg_rating_tip: 'ESG評級是以絕對評估表示　貴公司的ESG措施等級。基於ESG評分，分類為AAA～CCC的7階段。',
    evaluator_advice_title: '評估意見',
    list_header_buyer_company_name: '委託評估企業',
    list_header_supplier_company_name: '受評估企業',
    list_header_question: '@:common.upload.title',
    list_header_create_at: '發行日',
    list_header_deadline: '有效期限',
    list_header_industry: '業種',
    list_header_company_scale: '員工人數',
    download_csv: '輸出CSV檔',
    download_pdf: '輸出PDF檔',
    csv_title_for_buyer: '回答ASUENE ESG問卷',
    csv_title_for_supplier: 'ASUENE ESG',
    answer: '@:upload_common.question_group_download_answered_csv_title',
    download_answer_description: '以CSV格式下載回答。',
    answer_pdf: '@:upload_common.question_group_download_answered_pdf_title',
    download_answer_pdf_description: '以PDF格式下載回答。',
    scorecard_pdf: '評分卡(PDF)',
    download_scorecard_pdf_description: '以PDF格式下載評分。',
    feedback: '評估回饋',
    attached_file: "@:{'improvementplans.attached_file'}",
    download_feedback_description: '以PDF格式下載資料。',
    award_medal_svg: 'ESG大獎(SVG)',
    download_award_medal_svg_description: '下載SVG影像。',
    award_medal_png: 'ESG大獎(PNG)',
    download_award_medal_png_description: '下載PNG影像。',
    pdf_modal_sent_mail_section_one: '已受理輸出PDF檔要求。',
    pdf_modal_sent_mail_section_two: 'PDF下載URL會寄送至電子郵件地址，請稍候。',
    pdf_modal_sent_mail_section_three: '30分鐘後仍未收到郵件時請重試。',
  },
  category_score_section: {
    card_title: '按類別評分',
    tip: '按類別評分是針對 貴公司的環境、社會、治理所做的評分。各類別的提問權重，會依回答的企業而異。',
    policy: '規範、方針',
    action: '對策',
    result: '結果',
  },
  score_by_category_compared_section: {
    card_title: '按類別評分比較',
    get_score_by_category: '按已獲得的類別評分',
    esg_evaluated_all_companies_average: '接受ASUENE ESG評估的所有企業',
    tip: '已在同一份調查表／問卷調查上回答的企業平均評分。由於是現階段的平均値，因此數字有可能會有異動。',
  },
  strengths_advice_section: {
    card_title: '評分、問題點',
    strong_point: '評分',
    advice: '改善事項',
    policies: '規範、方針',
    action: '對策',
    result: '結果',
    no_results_for_this_category: '沒有與此類別相關的結果可以顯示。',
    risk: '風險程度',
    indicator: '指標',
    content: '內容',
    operation: '操作',
  },
  preview: {
    go_back_to_scorecard: '返回評分卡',
  },
  buyer_scorecard: {
    overview_card_title: '@:overall_score_section.card_title',
    score_card_title: '@:list_table_filter.csv_modal_score_title',
    evaluation_comment_card_title: '整體評分概要',
    category_card_tabs_risk: '@:improvementplans.risk',
    category_card_tabs_content: '@:scorecard.content',
    category_card_tabs_operation: '@:improvementplans.operation',
    category_card_score_title: '@:list_table_filter.csv_modal_score_title',
    category_card_score_average: '平均:',
    category_card_score_no_score: '非適用對象',
    category_card_score_earned_score: '得分',
    category_card_details_list_title: '評估意見',
    category_card_details_no_score_tip: '本類別不列入評估。',
    category_card_score_average_score: '其他公司的平均評分',
    category_card_details_title: '各類別評分概要',
    category_card_details_strengths: '@:strengths_advice_section.strong_point',
    category_card_details_indicated_points: '@:strengths_advice_section.advice',
    no_score_tip: '由於是依照委託評估企業制定的評估邏輯計分，故不列為評估項目。',
    buyer_evaluate_tip: '依照委託評估企業制定的評估邏輯來計分。ASUENE ESG的評估邏輯中並未計分。',
    answer_rejection_notification: '您有一件企業的撤銷要求',
    answer_rejection_modal_title: '退回回覆',
    answer_rejection_modal_text: '退回意見',
    answer_rejection_modal_content: '即將退回{companyName}的回覆。\n請於下方填寫給承辦人的退回意見再發送。',
    answer_rejection_dialog_content: '已退回{companyName}的回覆。',
    answer_rejection_button_title: '退回',
  },
}
